import type { Feature } from '@luna/gatekeeper';

export const cardClosingInfoScreen: Feature = {
    enabled: false,
    _description: 'Enables the new card closing detail screen.',
};
